module.exports = __webpack_public_path__ + "static/media/TOI1.88523c34.png";